/* Ube Time — interactions pages internes : stepper qty, ajout panier AJAX,
   barre d'achat mobile, toggle contact, sommaire du guide. Repris de la maquette. */
(function () {
  'use strict';
  var root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';

  /* ---------- Révélation au scroll (.reveal -> .in) ----------
     Repris de ube-home.js : les pages internes (guide, etc.) utilisent aussi .reveal
     mais ne chargent pas ube-home.js. Sans cet observateur, les .reveal restent à
     opacity:0 (le repli CSS html:not(.ube-js) est neutralisé car .ube-js est présent). */
  (function () {
    var inEditor = window.Shopify && window.Shopify.designMode;
    function showAll(r) { (r || document).querySelectorAll('.reveal:not(.in)').forEach(function (e) { e.classList.add('in'); }); }
    function reveal(r) {
      var els = (r || document).querySelectorAll('.reveal:not(.in)');
      if (!els.length) return;
      if (inEditor || !('IntersectionObserver' in window)) { showAll(r); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
      els.forEach(function (e) { io.observe(e); });
      setTimeout(function () { showAll(r); }, 2500);
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { reveal(); }); } else { reveal(); }
    document.addEventListener('shopify:section:load', function (e) { reveal(e.target); });
  })();

  /* ---------- Prix dynamique (unité × quantité), comme la maquette ---------- */
  function eurFmt(n) { return n.toFixed(2).replace('.', ',') + ' €'; }
  function updateBuyPrice() {
    var priceEl = document.querySelector('.price[data-unit]');
    var qtyInput = document.querySelector('form[data-ube-buyform] input[name="quantity"]');
    if (!priceEl || !qtyInput) return;
    var unit = parseFloat(priceEl.getAttribute('data-unit'));
    if (isNaN(unit)) return;
    var qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
    var amt = priceEl.querySelector('.price-amount');
    if (amt) amt.innerHTML = eurFmt(unit * qty);
    var cmp = priceEl.getAttribute('data-compare');
    var s = priceEl.querySelector('s');
    if (s && cmp) s.innerHTML = eurFmt(parseFloat(cmp) * qty);
    var bp = document.querySelector('.buybar .bp');
    if (bp) { var nm = bp.getAttribute('data-name') || ''; bp.innerHTML = nm + ' · ' + eurFmt(unit * qty); }
  }

  /* ---------- Steppers quantité ---------- */
  document.querySelectorAll('.stepper').forEach(function (st) {
    var input = st.querySelector('input');
    if (!input) return;
    st.querySelectorAll('button[data-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        v += parseInt(b.getAttribute('data-step'), 10);
        if (v < 1) v = 1;
        input.value = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    input.addEventListener('change', updateBuyPrice);
    input.addEventListener('input', updateBuyPrice);
  });

  /* ---------- Ajout au panier (AJAX) + tiroir ---------- */
  function openDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') { drawer.open(); return true; }
    return false;
  }
  function addToCart(variantId, qty, btn) {
    if (!variantId) return;
    var original = btn ? btn.innerHTML : '';
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] })
    }).then(function (r) { return r.json(); })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); btn.innerHTML = original; }
        if (!openDrawer()) { window.location.href = root + 'cart'; }
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); btn.innerHTML = original; }
        window.location.href = root + 'cart';
      });
  }

  document.querySelectorAll('form[data-ube-buyform]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return; // fallback : POST natif vers /cart/add
      e.preventDefault();
      var id = form.querySelector('[name="id"]');
      var qty = form.querySelector('[name="quantity"]');
      addToCart(id && id.value, qty ? parseInt(qty.value, 10) : 1, form.querySelector('[type="submit"]'));
    });
  });

  /* Bouton de la barre d'achat mobile */
  document.querySelectorAll('[data-buybar-add]').forEach(function (b) {
    b.addEventListener('click', function () {
      addToCart(b.getAttribute('data-variant'), 1, b);
    });
  });

  /* ---------- Barre d'achat mobile : visible après le hero ---------- */
  var buybar = document.querySelector('.buybar');
  if (buybar) {
    var hero = document.querySelector('.prod-hero');
    var onScroll = function () {
      if (!hero) return;
      var past = hero.getBoundingClientRect().bottom < 0;
      buybar.classList.toggle('show', past);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Toggle contact (Particulier / Professionnel) ---------- */
  var toggle = document.getElementById('contactToggle');
  if (toggle) {
    var slider = toggle.querySelector('.slider');
    var btns = toggle.querySelectorAll('button');
    var panelPart = document.getElementById('contact-part');
    var panelPro = document.getElementById('contact-pro');
    var setContact = function (which) {
      var isPro = which === 'pro';
      btns.forEach(function (b) {
        var on = b.id === (isPro ? 'tab-pro' : 'tab-part');
        b.classList.toggle('on', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      toggle.classList.toggle('is-pro', isPro);
      if (panelPart) { panelPart.hidden = isPro; panelPart.style.display = isPro ? 'none' : ''; }
      if (panelPro) { panelPro.hidden = !isPro; panelPro.style.display = isPro ? '' : 'none'; }
      // Le panneau affiché était en display:none → l'observateur reveal ne l'a pas vu : on force l'état visible du wrapper d'animation.
      var shown = isPro ? panelPro : panelPart;
      if (shown) { shown.querySelectorAll('.reveal').forEach(function (r) { r.classList.add('in'); }); }
    };
    btns.forEach(function (b) {
      b.addEventListener('click', function () { setContact(b.id === 'tab-pro' ? 'pro' : 'part'); });
    });
    // état initial d'après le hash (#pro) ou la valeur d'erreur du form
    if (location.hash === '#pro' || document.querySelector('#contact-pro .form-status--error')) setContact('pro');
  }

  /* ---------- Filet de sécurité : garantir que le formulaire est visible ----------
     L'animation d'entrée .form-reveal ne doit jamais laisser le formulaire masqué. */
  document.querySelectorAll('.form-reveal').forEach(function (fr) {
    var lock = function () { fr.style.opacity = '1'; fr.style.transform = 'none'; };
    fr.addEventListener('animationend', lock);
    setTimeout(lock, 1200);
  });

  /* ---------- Sommaire du guide : défilement doux ---------- */
  window.gjump = function (id) {
    var el = document.getElementById(id);
    if (!el) return;
    var top = el.getBoundingClientRect().top + window.pageYOffset - 90;
    window.scrollTo({ top: top, behavior: 'smooth' });
  };
  document.querySelectorAll('.g-toc-inner a[data-target]').forEach(function (a) {
    a.addEventListener('click', function (e) { e.preventDefault(); window.gjump(a.getAttribute('data-target')); });
  });

  /* Boutons "jump vers formulaire" (Pro) */
  document.querySelectorAll('[data-jump]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault();
      window.gjump(b.getAttribute('data-jump'));
    });
  });

  /* ---------- Buy box (formats 1/2/3 + Abonnement / Achat unique) ---------- */
  function eur2(n) { return Number(n).toFixed(2).replace('.', ',') + ' €'; }
  document.querySelectorAll('[data-ube-buybox]').forEach(function (form) {
    var cfgEl = form.querySelector('[data-bb-config]');
    if (!cfgEl) return;
    var cfg; try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    var formats = cfg.formats || [];
    if (!formats.length) return;
    var i18n = cfg.i18n || {};
    var state = { f: 1, m: 'one' };

    var box = form.querySelector('[data-bb-formats]');
    var qtyInput = form.querySelector('[data-bb-qty]');
    var planInput = form.querySelector('[data-bb-plan]');
    var idInput = form.querySelector('[name="id"]');
    var nowEl = form.querySelector('[data-bb-now]');
    var wasEl = form.querySelector('[data-bb-was]');
    var subNote = form.querySelector('[data-bb-subnote]');
    var crossNote = form.querySelector('[data-bb-crossnote]');
    var stockEl = form.querySelector('[data-bb-stock]');
    var stockTxt = form.querySelector('[data-bb-stocktxt]');
    var cta = form.querySelector('[data-bb-cta]');
    var buybar = document.querySelector('.buybar');
    var buybarTxt = buybar ? buybar.querySelector('[data-bb-buybar]') : null;
    var buybarAdd = buybar ? buybar.querySelector('[data-bb-add]') : null;
    var addLabel = cta ? cta.innerHTML : 'Ajouter au panier';

    function fmt(n) { return formats[n - 1] || formats[0]; }

    function buildFormats() {
      box.innerHTML = '';
      formats.forEach(function (fo) {
        var out = (cfg.stockMode !== 'continue' && fo.stock === 0);
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ube-fmt' + (fo.n === state.f ? ' on' : '') + (out ? ' soldout' : '');
        b.setAttribute('data-f', fo.n);
        var noun = fo.n > 1 ? (i18n.nounP || (cfg.noun + 's')) : (i18n.nounS || cfg.noun);
        b.innerHTML = '<div class="ube-fn">' + fo.n + '</div><div class="ube-fu">' + noun + '</div>' +
          (fo.n === 3 && !out ? '<span class="ube-ftag">' + (i18n.best || 'Le + choisi') + '</span>' : '');
        b.addEventListener('click', function () { if (out) return; state.f = fo.n; render(); });
        box.appendChild(b);
      });
    }

    function render() {
      var fo = fmt(state.f);
      box.querySelectorAll('.ube-fmt').forEach(function (b) { b.classList.toggle('on', +b.getAttribute('data-f') === state.f); });
      form.querySelectorAll('.ube-mode').forEach(function (b) { b.classList.toggle('on', b.getAttribute('data-m') === state.m); });

      var price = state.m === 'sub' ? fo.sub : fo.one;
      nowEl.textContent = eur2(price);
      if (state.m === 'sub') {
        wasEl.style.display = 'inline'; wasEl.textContent = eur2(fo.one); subNote.style.display = 'flex';
        if (crossNote) crossNote.style.display = 'none';
      } else {
        subNote.style.display = 'none';
        if (crossNote) crossNote.style.display = 'block';
        var unit = formats[0].one;
        if (fo.n > 1) { wasEl.style.display = 'inline'; wasEl.textContent = eur2(unit * fo.n); }
        else { wasEl.style.display = 'none'; }
      }

      if (planInput) {
        if (state.m === 'sub' && fo.plan) { planInput.value = fo.plan; planInput.disabled = false; }
        else { planInput.value = ''; planInput.disabled = true; }
      }
      if (idInput && fo.variant) idInput.value = fo.variant;
      if (qtyInput) qtyInput.value = cfg.perVariant ? 1 : fo.n;

      stockEl.classList.remove('ok', 'low', 'out');
      if (cfg.stockMode === 'continue') {
        stockEl.classList.add('ok'); stockTxt.textContent = (i18n.inStock || 'En stock · expédié sous 48h'); cta.disabled = false; cta.innerHTML = addLabel;
      } else {
        var s = fo.stock;
        if (s === 0) { stockEl.classList.add('out'); stockTxt.textContent = (i18n.soon || 'Bientôt de retour'); cta.disabled = true; cta.innerHTML = (i18n.unavail || 'Indisponible'); }
        else if (s <= (cfg.low || 6)) { stockEl.classList.add('low'); stockTxt.textContent = (i18n.lowPre || 'Plus que ') + s + (i18n.lowPost || ' en stock'); cta.disabled = false; cta.innerHTML = addLabel; }
        else { stockEl.classList.add('ok'); stockTxt.textContent = (i18n.inStock || 'En stock · expédié sous 48h'); cta.disabled = false; cta.innerHTML = addLabel; }
      }

      if (buybarTxt) buybarTxt.innerHTML = (buybarTxt.getAttribute('data-name') || '') + ' · ' + eur2(price);
    }

    form.querySelectorAll('.ube-mode').forEach(function (b) {
      b.addEventListener('click', function () { state.m = b.getAttribute('data-m'); render(); });
    });

    function refreshDrawer() {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer) { return Promise.resolve(false); }
      return fetch(root + '?section_id=cart-drawer')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('#CartDrawer');
          var cur = drawer.querySelector('#CartDrawer');
          if (fresh && cur) { cur.innerHTML = fresh.innerHTML; }
          var inner = drawer.querySelector('.drawer__inner');
          if (inner) { inner.classList.remove('is-empty'); }
          drawer.classList.remove('is-empty');
          if (typeof drawer.open === 'function') { drawer.open(); }
          else { drawer.classList.add('active'); document.body.classList.add('overflow-hidden'); }
          return true;
        });
    }

    function addBB(btn) {
      var fo = fmt(state.f);
      if (cfg.stockMode !== 'continue' && fo.stock === 0) return;
      var item = { id: fo.variant || cfg.variant, quantity: cfg.perVariant ? 1 : fo.n };
      if (state.m === 'sub' && fo.plan) item.selling_plan = fo.plan;
      var original = btn ? btn.innerHTML : '';
      if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
      fetch(root + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [item] })
      }).then(function (r) { if (!r.ok) { throw new Error('add'); } return r.json(); })
        .then(function () { document.dispatchEvent(new CustomEvent('cart:refresh')); return refreshDrawer(); })
        .then(function (ok) {
          if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); btn.innerHTML = original; }
          if (ok === false) { window.location.href = root + 'cart'; }
        })
        .catch(function () {
          if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); btn.innerHTML = original; }
          window.location.href = root + 'cart';
        });
    }

    form.addEventListener('submit', function (e) { if (!window.fetch) return; e.preventDefault(); addBB(cta); });
    if (buybarAdd) buybarAdd.addEventListener('click', function () { addBB(buybarAdd); });

    buildFormats();
    render();
  });

  /* ---------- Libellé des lignes panier : "Format: 1 sachet" -> "1 sachet" / "Abonnement 1 sachet" ---------- */
  function ubeRelabelCart() {
    var L = (document.documentElement.lang || 'fr').slice(0, 2).toLowerCase();
    var SUBW = ({ fr: 'Abonnement', en: 'Subscription', de: 'Abo', es: 'Suscripción', it: 'Abbonamento', nl: 'Abonnement', pt: 'Assinatura' })[L] || 'Abonnement';
    document.querySelectorAll('.cart-item__details').forEach(function (det) {
      var planP = det.querySelector(':scope > p.product-option');
      var isSub = !!(planP && planP.textContent.replace(/\s/g, '') !== '');
      var dl = det.querySelector('dl');
      if (dl) {
        dl.querySelectorAll('.product-option').forEach(function (row) {
          if (row.getAttribute('data-ube-rl')) return;
          var dt = row.querySelector('dt');
          var dd = row.querySelector('dd');
          if (dt && dd && /format|formaat|formato/i.test(dt.textContent)) {
            row.setAttribute('data-ube-rl', '1');
            var val = dd.textContent.replace(/[,\s]+$/, '').trim();
            dt.style.display = 'none';
            dd.textContent = (isSub ? SUBW + ' ' : '') + val;
          }
        });
      }
      if (planP && !planP.getAttribute('data-ube-rl')) { planP.setAttribute('data-ube-rl', '1'); planP.style.display = 'none'; }
    });
  }
  ubeRelabelCart();
  if (window.MutationObserver) {
    var cartRoot = document.querySelector('cart-drawer') || document.querySelector('#main-cart-items') || document.body;
    if (cartRoot) { new MutationObserver(function () { ubeRelabelCart(); }).observe(cartRoot, { childList: true, subtree: true }); }
  }
})();
